export default __webpack_public_path__ + "static/media/ic_manage-banner.6b0014b6.svg";